/**
 * 택배사 재인증 전체 화면 모달 관리
 * 모달이지만 페이지처럼 보여서 닫기를 눌러도 뒤에서 재조회가 일어나지 않음
 *
 * TODO: 공유 코드 추출 필요 (우선순위: HIGH)
 * - 이 파일은 Admin과 Mobile에서 100% 동일합니다 (62줄)
 * - farmfree/packages/farmfree-common/shared-composables/courier/shared-useCourierErrorHandler.ts 로 이동 권장
 * - CLAUDE.md의 "공유 코드 동기화 규칙" 참조
 */

import { ref } from 'vue'

/**
 * 재인증 모달 상태 인터페이스
 */
export interface ReauthModalState {
  isOpen: boolean
  courierId: string
  companyId: string
  onSuccess: (() => void) | null
  onClose: (() => void) | null
}

// 재인증 모달 상태 (전역 singleton)
const reauthModalState = ref<ReauthModalState>({
  isOpen: false,
  courierId: '',
  companyId: '',
  onSuccess: null,
  onClose: null,
})

/**
 * 택배사 재인증 모달 관리 composable
 */
export function useCourierErrorHandler() {
  /**
   * 재인증 모달 열기
   */
  function openReauthModal(
    courierId: string,
    companyId: string,
    onSuccess?: () => void,
    onClose?: () => void
  ) {
    reauthModalState.value = {
      isOpen: true,
      courierId,
      companyId,
      onSuccess: onSuccess || null,
      onClose: onClose || null,
    }
  }

  /**
   * 재인증 모달 닫기
   */
  function closeReauthModal() {
    reauthModalState.value.isOpen = false
  }

  return {
    reauthModalState,
    openReauthModal,
    closeReauthModal,
  }
}
